<template>
    <app-layout>
        <template #header>
            {{ trans("users.page_title.set_password") }}
        </template>

        <div class="px-6">
            <form @submit.prevent="submit">
                <div class="text-center">
                    <span class="text-gray-700 text-center text-lg">{{
                        trans("passwords.change_initial_password_subtitle")
                    }}</span>
                    <div class="mt-6 sm:mt-5 space-y-6 sm:space-y-5 text-left">
                        <div
                            class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                        >
                            <label
                                for="name"
                                class="block font-medium text-gray-700 sm:mt-px sm:pt-2"
                            >
                                {{ trans("users.label.password")
                                }}<span class="text-red-500">*</span>
                            </label>

                            <div class="mt-1 sm:mt-0 sm:col-span-2">
                                <input
                                    type="password"
                                    name="password"
                                    id="password"
                                    v-model="form.password"
                                    class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                    :class="[
                                        {
                                            'border border-red-500':
                                                form.errors.password,
                                        },
                                    ]"
                                />
                                <small
                                    class="text-red-500"
                                    v-if="form.errors.password"
                                >
                                    <strong>{{ form.errors.password }}</strong>
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="mt-6 sm:mt-5 space-y-6 sm:space-y-5 text-left">
                        <div
                            class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                        >
                            <label
                                for="name"
                                class="block font-medium text-gray-700 sm:mt-px sm:pt-2"
                            >
                                {{ trans("users.label.password_confirmation") }}
                                <span class="text-red-500">*</span>
                            </label>

                            <div class="mt-1 sm:mt-0 sm:col-span-2">
                                <input
                                    type="password"
                                    name="password_confirmation"
                                    id="password_confirmation"
                                    v-model="form.password_confirmation"
                                    class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                    :class="[
                                        {
                                            'border border-red-500':
                                                form.errors
                                                    .password_confirmation,
                                        },
                                    ]"
                                />
                                <small
                                    class="text-red-500"
                                    v-if="form.errors.password_confirmation"
                                >
                                    <strong>
                                        {{ form.errors.password_confirmation }}
                                    </strong>
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="mt-8 sm:mt-0 pt-8 flex justify-end">
                        <button type="submit">
                            <StyledButton background-primary>{{
                                trans("button.submit")
                            }}</StyledButton>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import StyledButton from "@/Components/StyledButton.vue";

export default {
    components: {
        AppLayout,
        StyledButton,
    },

    data() {
        return {
            form: this.$inertia.form({
                password: "",
                password_confirmation: "",
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(
                this.route("user-password", {
                    password: this.form.password,
                    password_confirmation: this.form.password_confirmation,
                })
            );
        },
    },
};
</script>
